import { em, rem } from 'polished'
import styled from 'styled-components'

import { FlexRowStyled } from '@ui/elements/Flex/styles/FlexRowStyled'

interface IImageCropperStyledProps {}

export const ImageCropperStyled = styled.div<IImageCropperStyledProps>`
  font-size: ${rem(16)};

  position: relative;
  width: 100%;
  height: calc(100% - 2.5em);

  ${FlexRowStyled} {
    position: absolute;
    width: 100%;
    bottom: -2.5em;
    margin: 0;
  }
`
